import Markdown from "react-markdown";
import rehypeExternalLinks from "rehype-external-links";
import styled, { css } from "styled-components";
import { getTheme, Strut, type FontPalette, type CssSpaceValue, type ColorDeclaration, type ThemePalette, } from "@bracket/ui";
import type { FunctionComponent, ReactNode, } from "react";
import type { PrefixKeys, } from "@bracket/types";


export declare type MarkDownWrappedProps = {
	headingFont?: keyof FontPalette;
	headingSize?: CssSpaceValue;
	headingLineHeight?: CssSpaceValue;
	headingColor?: ColorDeclaration | keyof ThemePalette;
	font?: keyof FontPalette;
	fontSize?: CssSpaceValue;
	lineHeight?: CssSpaceValue;
	color?: ColorDeclaration | keyof ThemePalette;
	children: string | string[] | ReactNode;
};


export const MarkDownWrapped: FunctionComponent<MarkDownWrappedProps> = ({
	children,
	...props
}) => {
	return (
		<Brace {...Object.entries(props).reduce((acc, [k,v]) => ({ [`$${k}`]: v, ...acc }), {} as PrefixKeys<"$", MarkDownWrappedProps>)}>
			<Markdown rehypePlugins={[[rehypeExternalLinks, { target: "_blank" }]]}>
				{children?.toString() as string}
			</Markdown>
		</Brace>
	);
};

const Test = css`
	h1 {
		font-family: ${() => getTheme().fonts.body};
		font-size: 20px;
		color: ${() => getTheme().typeface.h1.color};
		line-height: 36px;
		font-weight: 500;
	}
	p, li {
		font-size: 16px;
	}
	br {
		display: block;
		height: 50px;
		clear: both;
		line-height: 50px;
	}
	ul {
		li {
			padding: 0.5rem 0;
			line-height: 20px;
		}
	}
	a {
		color: ${() => getTheme().primary };
		&:visited {
			color: ${() => getTheme().primary };
		}
	}

`

const Brace = styled(Strut)<PrefixKeys<"$", MarkDownWrappedProps>>`

	padding: 1rem 0;

	p {
		color: ${({ $color }) => $color ? $color in getTheme() ? getTheme()[$color as keyof ThemePalette] : $color as ColorDeclaration : getTheme().typeface.p.md.color };
		font-size: ${({ $fontSize }) => $fontSize || getTheme().typeface.p.md.size };
		line-height: ${({ $lineHeight }) => $lineHeight || getTheme().typeface.p.md.lineHeight };
		font-family: ${({ $font }) => $font ? getTheme().fonts[$font as keyof FontPalette] : getTheme().typeface.p.md.font };
	}

	h1 {
		color: ${({ $headingColor }) => $headingColor ? $headingColor in getTheme() ? getTheme()[$headingColor as keyof ThemePalette] : $headingColor as ColorDeclaration : getTheme().typeface.p.md.color };
		font-family: ${({ $headingFont }) => $headingFont ? getTheme().fonts[$headingFont as keyof FontPalette] : getTheme().typeface.p.md.font };
  }

	li {
		padding: 0.5rem 0;
	}

	a {
		color: ${() => getTheme().primary_on };
		&:visited {
			color: ${() => getTheme().primary };
		}
	}
	
	${Test}
`;
